import { StyleRules } from "@material-ui/core";
import { WHITE } from "constants/colors";

export const styles: StyleRules = {
  moveCardText: {
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "16px",
    lineHeight: "19px",
    color: WHITE,
  },

  moveCardTitle: {
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "14px",
    lineHeight: "16px",
    color: "#C6D1E0",
  },
  moveCardBtn: {
    border: "none",
    backgroundColor: "#171a1f",
    padding: " 15px 0px 10px 0px",
    fontSize: "16px",
    cursor: "pointer",
    color: "#90caf9",
    display: "flex",
    alignItems: "center",
    width: "auto",
    "& > img": {
      marginRight: "10px",
    },
  },

  moveCardhHrTag: {
    background: "#737980",
    height: "1px",
    border: " 0",
    marginTop: "10px",
  },
  componentDisabled: {
    opacity: 0.2,
  },
  btnDisabled: {
    opacity: 0.5,
  },
};
